import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface RepairReturnChoice {
  /** true: rientra lo stesso seriale riparato; false: il fornitore lo ha sostituito */
  same_serial: boolean;
  /** Seriale nuovo che rientra (solo se same_serial è false) */
  new_serial?: string;
}

/**
 * Il seriale che rientra è in riparazione presso il fornitore (casa madre): si chiede se è
 * rientrato lo stesso seriale o se il fornitore lo ha sostituito (in quel caso si indica il
 * nuovo seriale, che viene serializzato con il rientro).
 * Si chiude con un RepairReturnChoice, oppure senza valore se l'utente annulla.
 */
@Component({
  selector: 'app-modal-repair-return',
  templateUrl: './modal-repair-return.component.html',
  styleUrls: ['./modal-repair-return.component.scss'],
})
export class ModalRepairReturnComponent {
  serialNumber: string;
  productName?: string;
  /** Seriale che il cliente ha già ricevuto in sostituzione di quello in riparazione */
  alreadyReplacedBy?: string;
  mode: 'same' | 'replaced' | null = null;
  newSerial = new FormControl<string>('', [Validators.required]);

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.serialNumber = config.data?.serialNumber ?? '';
    this.productName = config.data?.productName;
    this.alreadyReplacedBy = config.data?.alreadyReplacedBy;
  }

  private get normalizedNewSerial(): string {
    return (this.newSerial.value ?? '').trim().toUpperCase();
  }

  get sameAsOld(): boolean {
    return this.normalizedNewSerial === this.serialNumber.trim().toUpperCase();
  }

  get canConfirm(): boolean {
    if (this.mode === 'same') return true;
    if (this.mode === 'replaced') return !!this.normalizedNewSerial && !this.sameAsOld;
    return false;
  }

  close() {
    this.ref.close();
  }

  confirm() {
    if (!this.canConfirm) return;
    const choice: RepairReturnChoice =
      this.mode === 'same'
        ? { same_serial: true }
        : { same_serial: false, new_serial: this.normalizedNewSerial };
    this.ref.close(choice);
  }
}
